import React, { memo } from 'react';
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import CommonTypography from '@src/new-components/Typography';
import Tooltip from '@src/components/Tooltip';
import { StyledStyleCard } from './index.style';
import toSampleStyle from './sampleStyle';

const StyleCard = ({
  styleId,
  label,
  config,
  isSelected,
  configureLabel,
  onSelect,
  onConfigure,
}) => {
  const sample = toSampleStyle(config);

  return (
    <StyledStyleCard
      isSelected={isSelected}
      onClick={() => onSelect(styleId, config)}
    >
      <div className="style-preview">
        <CommonTypography
          className="style-sample"
          variant="body-24-bold"
          style={sample?.block}
        >
          <span style={sample?.glyph}>{label}</span>
        </CommonTypography>
      </div>

      <div className="style-row">
        <CommonTypography className="style-name" variant="body-14-medium">
          {label}
        </CommonTypography>
        <Tooltip title={configureLabel} placement="top" arrow>
          <button
            type="button"
            className="style-config-button"
            aria-label={configureLabel}
            onClick={(event) => {
              event.stopPropagation();
              onConfigure(styleId, config);
            }}
          >
            <TuneRoundedIcon />
          </button>
        </Tooltip>
      </div>
    </StyledStyleCard>
  );
};

export default memo(StyleCard);
